import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../store/axios';
import './unsubscribe.css';

const Unsubscribe = () => {
  const { trackingId } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, already, error
  const didFire = useRef(false);

  useEffect(() => {
    if (!trackingId || didFire.current) return;
    didFire.current = true;

    const processUnsubscribe = async () => {
      try {
        const { data } = await axios.post(`/campaign/track/unsubscribe/${trackingId}`);
        setStatus(data?.status || 'error');
      } catch (err) {
        const errorStatus = err?.response?.data?.status;
        setStatus(errorStatus || 'error');
      }
    };

    processUnsubscribe();
  }, [trackingId]);

  const messages = {
    loading: { title: 'Processing...', body: 'Please wait while we process your request.', icon: 'hourglass', color: '#6b7280' },
    success: { title: 'Unsubscribed Successfully', body: 'You have been unsubscribed and will no longer receive emails from this campaign.', icon: 'check', color: '#10b981' },
    already: { title: 'Already Unsubscribed', body: 'You have already been unsubscribed from this campaign.', icon: 'check', color: '#6b7280' },
    error: { title: 'Something Went Wrong', body: 'We could not process your unsubscribe request. Please contact the sender directly.', icon: 'error', color: '#ef4444' },
  };

  const msg = messages[status] || messages.error;

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-card">
        <div className="unsubscribe-icon" style={{ color: msg.color }}>
          {status === 'loading' && (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeDasharray="31.4" strokeDashoffset="10" strokeLinecap="round">
                <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite" />
              </circle>
            </svg>
          )}
          {(status === 'success' || status === 'already') && (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
              <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
          {status === 'error' && (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
              <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </div>
        <h1 className="unsubscribe-title">{msg.title}</h1>
        <p className="unsubscribe-body">{msg.body}</p>
      </div>
    </div>
  );
};

export default Unsubscribe;
